import { useNavigate } from "react-router-dom";
import { useState } from "react";
import styled from "styled-components";
import { Overlay } from "./modals.style";
import WarningImg from "../../assets/warning.png";
import BackgroundImage from "../../assets/bg-grid-2.png";
import Text from "../Text";
import Button from "../Button";
import YesBtn from "../../assets/yes-btn.png";
import NoBtn from "../../assets/no-btn.png";
import { GameLoss } from "../GameLoss"; // ✅ Import GameLoss
import { GameWin } from "../GameWin";

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: url(${BackgroundImage});
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #fefbed;
  border-radius: 10px;
  padding: 50px 130px;
  z-index: 1000;
  width: 300px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ModalImage = styled.img`
  width: 75px;
  height: 75px;
`;

const LoosingProgressModal = ({ open, onClose, castleId }) => {
  const navigate = useNavigate();
  const [showGameLoss, setShowGameLoss] = useState(false);

  if (!open) return null;

  const handleLoseProgress = () => {
    // ✅ Reset points
    sessionStorage.removeItem(`points_${castleId}`);

    // ✅ Remove from conquered
    const conqueredCastles = JSON.parse(sessionStorage.getItem("conquered_castles") || "[]");
    const updatedConquered = conqueredCastles.filter((id) => id !== castleId);
    sessionStorage.setItem("conquered_castles", JSON.stringify(updatedConquered));

    // ✅ Mark as failed (again)
    const failedCastles = JSON.parse(sessionStorage.getItem("failed_castles") || "[]");
    if (!failedCastles.includes(castleId)) {
      failedCastles.push(castleId);
      sessionStorage.setItem("failed_castles", JSON.stringify(failedCastles));
    }

    console.log(`🛑 Progress reset for Castle ${castleId} and marked as failed.`);

    
const totalFailed = failedCastles.length;
const totalConquered = conqueredCastles.length;
const totalPlayed = totalFailed + totalConquered;

if (totalPlayed >= 11 && totalConquered >= 9) {
  setShowGameLoss("win"); // Show GameWin instead
} else if (totalFailed >= 3) {
  setShowGameLoss(true); // Show GameLoss
} else {
  navigate("/play"); // Go back to map
}

  };

  if (showGameLoss === "win") {
    return <GameWin />;
  }
  
  if (showGameLoss === true) {
    return <GameLoss />;
  }
  
  return (
    <>
      <Overlay />
      <ModalContainer>
        <ModalImage src={WarningImg} alt="Warning" />
        <Text
          fontFamily="'Source Serif 4'"
          fontWeight="700"
          fontSize="40px"
          lineheight="55px"
          color="#3E626A"
          margin="-15px 0 10px 0"
        >
          Προσοχή
        </Text>
        <Text
          fontFamily="Manrope"
          fontWeight="600"
          fontSize="16px"
          lineheight="21.86px"
          color="#3E626A"
          margin="0 0 25px 0"
        >
          Βγαίνοντας θα χάσετε την πρόοδο σας, είστε σίγουροι?
        </Text>
        <div style={{ display: "inline-flex", gap: "20px" }}>
          <Button onClick={onClose} imgurl={NoBtn} />
          <div onClick={handleLoseProgress}
          >
            <Button imgurl={YesBtn} />
          </div>
        </div>
      </ModalContainer>
    </>
  );
};

export default LoosingProgressModal;
